import * as Fetch from '../data/Fetch';

const setAllSettingsType = 'SET_ALL_SETTINGS';
const setSettingsColumnsUsedType = 'SET_SETTINGS_USED';
const setSettingsColumnsIgnoredType = 'SET_SETTINGS_IGNORED';
const setSettingsFetchingType = 'SET_SETTINGS_FETCHING';

const defaultColumnData = {
	columnsUsed: [
		 { fieldname: "unread", text: "Unread", sortOrder: 10 },
		 { fieldname: "recordDateTime", text: "Record DateTime", sortOrder: 20 },
		 { fieldname: "patientCode", text: "Patient", sortOrder: 30 },
		 { fieldname: "serviceType", text: "Service Type", sortOrder: 40 },
		 { fieldname: "schedule", text: "Schedule", sortOrder: 50 },
		 { fieldname: "predominantRhythm", text: "Predominant Rhythm", sortOrder: 60 },
		 { fieldname: "erk", text: "ERK", sortOrder: 70 },
		 // { fieldname: "postedDateTime", text: "Posted DateTime", sortOrder: 70 },
		 { fieldname: "siteName", text: "Site", sortOrder: 80 },
		 { fieldname: "studyName", text: "Study", sortOrder: 90 },
	],
	 columnsIgnored: [
		 { fieldname: "qaCompleteDateTime", text: "QA Completion Date", sortOrder: 1010 },
		 { fieldname: "isQaComplete", text: "Is QA Complete", sortOrder: 1020 },
		 // { fieldname: "totalDuration", text: "Total Duration", sortOrder: 1030 },
		 // { fieldname: "analyzableDuration", text: "Analyzable Duration", sortOrder: 1080 },
		 { fieldname: "findings", text: "Clinical Findings", sortOrder: 1100 },
		 { fieldname: "mdOverreadFindings", text: "MD Findings", sortOrder: 1110 },
		 { fieldname: "physicianName", text: "Physician", sortOrder: 1015 },
		 // { fieldname: "symptomatic", text: "Symptomatic", sortOrder: 1120 },
		 // { fieldname: "symptoms", text: "Symptoms", sortOrder: 1130 },
		 // { fieldname: "activities", text: "Activities", sortOrder: 1140 },
		 // { fieldname: "heartratemetrics", text: "Heartrate metrics", sortOrder: 1150 },
		 { fieldname: "enrollmentReportKey", text: "Enrollment Report Key", sortOrder: 1160 },
		 { fieldname: "isMdOverreadComplete", text: "Is Md Overread Complete", sortOrder: 1170 },
		 { fieldname: "statusDescription", text: "Status", sortOrder: 1175 },
		 // { fieldname: "hasRhythmAfib", text: "Has Rhythm: Afib", sortOrder: 1180 },
		 // { fieldname: "hasRhythmAflutter", text: "Has Rhythm: Aflutter", sortOrder: 1190 },
		 // { fieldname: "hasRhythmAtachy", text: "Has Rhythm: Atachy", sortOrder: 1200 },
		 // { fieldname: "hasGt30RhythmAfib", text: "Has > 30 Rhythm: Afib", sortOrder: 1210 },
		 // { fieldname: "hasGt30RhythmAflutter", text: "Has > 30 Rhythm: Aflutter", sortOrder: 1220 },
		 // { fieldname: "hasGt30RhythmAtachy", text: "Has > 30 Rhythm: Atachy", sortOrder: 1230 },
		 // { fieldname: "rhythmDurationAfib", text: "Rhythm Duration: Afib", sortOrder: 1240 },
		 // { fieldname: "rhythmDurationAflutter", text: "Rhythm Duration: Aflutter", sortOrder: 1250 },
		 // { fieldname: "rhythmDurationAtachy", text: "Rhythm Duration: Atachy", sortOrder: 1260 },
	 ],
};

const initialState = {
    columnsUsed: null,
    columnsIgnored: null,
};

export const actionCreators = {

    createSettings: (columnsUsed,ColumnsIgnored) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const settingsState = getState().settings;

        const url = await Fetch.getUrl("Accounts/AddNewSettings");
        const body = JSON.stringify({
            columnsUsed: settingsState.columnsUsed,
            columnsIgnored: settingsState.columnsIgnored,
        });
        await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;

        const url = await Fetch.getUrl("Accounts/GetSettings");
        let data = await Fetch.getRequest(url, accountsState.authenticatedToken);
		if ( data == null || (data.columnsIgnored == null && data.columnsUsed == null) ) {
			data = initialState;
			data.columnsIgnored = defaultColumnData.columnsIgnored;
			data.columnsUsed = defaultColumnData.columnsUsed;
		}

        setResponse(data, dispatch, setAllSettingsType);
		dispatch({ type: setAllSettingsType, data });
    },



    set: (name,data) => async (dispatch) => {
		if ( name === "columnsUsed" ) {
			dispatch({ type: setSettingsColumnsUsedType, data });
		}
		if ( name === "columnsIgnored" ) {
			dispatch({ type: setSettingsColumnsIgnoredType, data });
		}
    },


    updateSettings: (name,data) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const settingsState = getState().settings;

        const url = await Fetch.getUrl("Accounts/UpdateSettings");
        const body = JSON.stringify({
            columnsUsed: settingsState.columnsUsed,
            columnsIgnored: settingsState.columnsIgnored,
        });
        await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

};

function setFetching(data, dispatch) {
    dispatch({ type: setSettingsFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setSettingsFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setSettingsFetchingType) {
		if ( action.data ) {
			return {
				...state,
				columnsIgnored: action.data.columnsIgnored,
				columnsUsed: action.data.columnsUsed
			};
		}
    }

    if (action.type === setAllSettingsType) {
        return {
            ...state,
			columnsIgnored: action.data.columnsIgnored,
			columnsUsed: action.data.columnsUsed
        };
    }

    if (action.type === setSettingsColumnsIgnoredType) {
		return {
			...state,
			columnsIgnored: action.data
		};
	}

    if (action.type === setSettingsColumnsUsedType) {
		return {
			...state,
			columnsUsed: action.data
		};
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Settings.js